import { KindePropertiesProvider } from '@/context/kinde-properties-context';
import { useQueryKindePropertiesForContext } from '@/hooks/query/useQueryKindeProperties';
import type { PropsWithChildren } from 'react';

export function KindePropertiesQueryProvider({ children }: PropsWithChildren) {
  const kindePropertiesQuery = useQueryKindePropertiesForContext();

  return (
    <KindePropertiesProvider kindePropertiesQuery={kindePropertiesQuery}>
      {children}
    </KindePropertiesProvider>
  );
}
